import React from 'react'
import { Field, reduxForm } from 'redux-form';
import { Button, Grid } from '@material-ui/core';
import RenderTextFieldRedux from './RenderTextFieldRedux';

const validate = values => {
    const error = {}
    const pattern = new RegExp('^[A-Za-z ]+$', 'i');

    if (!pattern.test(values.description)) {
        error.description = "El concepto solo permite letras y espacios"
    }
    if (values.description) {
        if (values.description.toString().length > 60) {
            error.description = "El concepto solo permite hasta 60 carácteres."
        }
    }
    return error
}

const RenderDescriptionForm = props => {
    const { label, handleSubmit, valid, positive, getBack } = props
    return (
        <form onSubmit={handleSubmit} >
            <Field
                name="payments_description_input"
                id="description"
                component={RenderTextFieldRedux}
                label={label}
                fullWidth
                multiline
                //autoFocus = {true}
                rows={3}
            />
            <br></br>
            <Grid container spacing={3}>
                <Grid item xs={6} md={6} lg={6} xl={6}>
                    <Button
                        id={"pay_agrement_btn"}
                        fullWidth
                        variant="contained"
                        color='primary'
                        disabled={!valid}
                        type="submit" >{positive}</Button>

                </Grid>
                <Grid item xs={6} md={6} lg={6} xl={6}>

                    <Button
                        fullWidth
                        variant="outlined"
                        color='primary'
                        onClick={() => getBack(true)}
                        >Cancelar</Button>

                </Grid>
            </Grid>
        </form>
    );
}

const RenderDescriptionFormRedux = reduxForm(
    {
        form: 'RenderDescriptionForm',
        validate,
    }
)(RenderDescriptionForm)

export default RenderDescriptionFormRedux